import { definePreset } from '@primeuix/themes';

import datepicker from '@primeuix/themes/aura/datepicker';
import button from '@primeuix/themes/aura/button';
import inputtext from '@primeuix/themes/aura/inputtext';
import listbox from '@primeuix/themes/aura/listbox';
import popover from '@primeuix/themes/aura/popover';
import base from '@primeuix/themes/aura/base';

export const SlimPreset = definePreset({
  ...base,
  components: {
    datepicker,
    button,
    inputtext,
    listbox,
    popover,
  },
});
